import Data from '../data';
/**
 * Class for business logic
 */
var Prof = /** @class */ (function () {
    function Prof() {
    }
    /**
     * Import external scripts
     * @param attrs
     */
    Prof.requireRemote = function (attrs, callback) {
        return new Promise(function (resolve, reject) {
            var doc = document;
            var head = doc.head || doc.getElementsByTagName('head')[0];
            var node = doc.createElement('script');
            var supportOnload = 'onload' in node;
            var onload = function (evt) {
                node.onload = node.onerror = node.onreadystatechange = function () { };
                node = null;
                callback && callback(evt);
            };
            if (supportOnload) {
                node.onload = function (evt) {
                    onload(evt);
                    resolve(evt);
                };
                node.onerror = function (evt) {
                    onload(evt);
                    reject(evt);
                };
            }
            else {
                node.onreadystatechange = function () {
                    if (/loaded|complete/.test(node.readyState)) {
                        var evt = new Event('load');
                        onload(evt);
                        resolve(evt);
                    }
                };
            }
            Data.extend(node, attrs);
            head.appendChild(node);
        });
    };
    return Prof;
}());
export default Prof;
